// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1ODop","footer":"Form_footer__36ub7"};